import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    root: {
        width: '100%'
    },
    accordionSummary: {
        flexDirection: 'row-reverse',
        alignItems: 'flex-start',
        marginLeft: '-10px'
    },
    declineSummary: {
        backgroundColor: '#f7f7f7',
        borderRadius: '4px',
        flexDirection: 'row-reverse',
        alignItems: 'flex-start',
    },
    accordionDetails:{
        padding: '0 .75rem 1rem 3rem'
    },
    expanded: {minHeight: '0 !important'},
    content: {
        margin: '16px 10px',
        '&$expanded': {
            margin: '16px 10px 5px 10px'
        },
    },
    expandIcon: {
        transform: 'rotate(270deg)',
        '&$expanded': {
            transform: 'rotate(0deg)',
        },
    },
    declineExpand: {
        transform: 'rotate(270deg)',
        padding: '10px 2px',
        '&$expanded': {
            transform: 'rotate(0deg)',
        },
    },
    declineContent: {
        margin: '13px 10px',
        '&$expanded': {
            margin: '13px 10px 5px 10px'
        },
    },
    statusContent: {
        paddingTop: '0',
        paddingLeft: '3rem'
    }
}));

